import { gql, useMutation } from '@apollo/client'
import CancelIcon from '@mui/icons-material/Cancel'
import DeleteIcon from '@mui/icons-material/Delete'
import {
  Button,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'
import Modal from 'components/Modal'
import React, { useState } from 'react'
import { Dataroom } from 'utils/__generated__/graphql'

const DELETE_DATAROOM = gql`
  mutation DELETE_DATAROOM($id: ID!) {
    deleteDataroom(id: $id)
  }
`

function Delete({ dataroom }: { dataroom: Dataroom }) {
  const [open, setOpen] = useState<boolean>(false)

  const theme = useTheme()

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const [deleteDataroom] = useMutation(DELETE_DATAROOM)

  const handleDelete = () => {
    deleteDataroom({
      variables: { id: dataroom.id },
      onCompleted: handleClose,
      update(cache) {
        cache.modify({
          fields: {
            findDatarooms(_, { DELETE }) {
              return DELETE
            },
          },
        })
      },
    })
  }

  return (
    <React.Fragment>
      <Modal open={open} width="75%" maxWidth={420}>
        <Stack
          direction="row"
          sx={{ alignItems: 'center', justifyContent: 'space-between' }}
        >
          <Typography
            sx={{ ...theme.typography.h5, color: theme.palette.text.primary }}
          >
            Delete - {dataroom.name}
          </Typography>
          <CancelIcon
            onClick={handleClose}
            sx={{ cursor: 'pointer', color: theme.palette.error.main }}
          />
        </Stack>
        <Divider sx={{ mt: 1, mb: 1 }} />
        <Stack spacing={1}>
          <Typography
            sx={{
              ...theme.typography.body1,
              color: theme.palette.text.secondary,
            }}
          >
            Are you sure you want to delete this dataroom? This action cannot be
            undone.
          </Typography>
          <Stack
            direction="row"
            spacing={1}
            sx={{ justifyContent: 'flex-end' }}
          >
            <Button
              color="inherit"
              disableElevation
              onClick={handleClose}
              variant="contained"
              size="small"
            >
              Cancel
            </Button>
            <Button
              color="error"
              disableElevation
              onClick={handleDelete}
              variant="contained"
              size="small"
            >
              Delete
            </Button>
          </Stack>
        </Stack>
      </Modal>
      <IconButton onClick={handleOpen}>
        <Tooltip title="Delete" placement="top">
          <DeleteIcon />
        </Tooltip>
      </IconButton>
    </React.Fragment>
  )
}

export default Delete
